import { render } from "./coaches-grid-sidebar.vue?vue&type=template&id=9c9a8a8a"
import script from "./coaches-grid-sidebar.vue?vue&type=script&lang=js"
export * from "./coaches-grid-sidebar.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__